import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { formatMoneyWithSign } from '../../../helpers';

const InvoiceAmountCards = ({ cards, loading }) => (
  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2 }}>
    {cards.map((card) => (
      <Paper
        key={card.key}
        elevation={0}
        sx={{
          flex: 1,
          minWidth: 0,
          border: '1px solid',
          borderColor: 'gray.A300',
          borderRadius: 2,
          p: { xs: 1.5, md: 2 },
        }}
      >
        <Typography variant="small_1" color="text.secondary" display="block">
          {card.label}
        </Typography>
        {loading ? (
          <Skeleton variant="text" width={120} height={32} />
        ) : (
          <Typography
            variant="medium_3"
            fontWeight={700}
            color={card.isWarning ? 'error.A700' : 'gray.A700'}
          >
            {formatMoneyWithSign(card.value)}
          </Typography>
        )}
      </Paper>
    ))}
  </Box>
);

InvoiceAmountCards.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number, PropTypes.string]),
      isWarning: PropTypes.bool,
    }),
  ).isRequired,
  loading: PropTypes.bool,
};

InvoiceAmountCards.defaultProps = {
  loading: false,
};

export default InvoiceAmountCards;
